





























import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';
import { DropdownFilter, IDropdownFilter } from '@/models/filters/Filters';

const Component = defineComponent({
  name: 'ColorsTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.COLOR;

    const filtersDropdown: IDropdownFilter[] = [
      new DropdownFilter({
        label: 'Color Group',
        filterType: 'colorGroup',
        itemsModuleName: 'colorGroupsModule',
        hasDefaultValue: true,
      }),
    ];

    const state = reactive({
      headers: [
        { text: 'Color', value: 'color', sortable: false, editable: true },
        { text: 'Name', value: 'name', sortable: true, searchable: true },
        { text: 'HEX', value: 'value', align: 'center', sortable: false },
        { text: 'Position', value: 'position', align: 'center', sortable: true },
        {
          text: 'Color Group',
          value: 'colorGroups',
          align: 'center',
          sortable: true,
          editable: true,
        },
        { text: 'Details', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
      filtersDropdown,
    };
  },
});
export default Component;
